export default __webpack_public_path__ + "static/media/Daikin.2d10e7f8.png";